import { render, staticRenderFns } from "./ContentQuestions.vue?vue&type=template&id=dd3661e8&scoped=true"
import script from "./ContentQuestions.vue?vue&type=script&lang=js"
export * from "./ContentQuestions.vue?vue&type=script&lang=js"
import style0 from "./ContentQuestions.vue?vue&type=style&index=0&id=dd3661e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3661e8",
  null
  
)

export default component.exports